import React from 'react';

/**
 * Zoho Recruit product mark (icon only) from Zoho productlogos/recruit.svg.
 * https://www.zohowebstatic.com/sites/zweb/images/productlogos/recruit.svg
 */
const ZohoLogo = ({ size = 18, className = '', title = 'Zoho Recruit' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 260 296"
    fill="#E42527"
    role="img"
    aria-label={title}
    className={className}
  >
    <title>{title}</title>
    <path d="M131.4 293c-2.2 0-4.4-.8-6-2.5l-35.1-35.1c-1.6-1.6-2.5-3.8-2.5-6s.9-4.4 2.5-6l35.1-35.1c3.3-3.3 8.7-3.3 12 0l35.1 35.1c1.6 1.6 2.5 3.8 2.5 6s-.9 4.4-2.5 6l-35.1 35.1c-1.6 1.7-3.8 2.5-6 2.5zm-23.1-43.6 23.1 23.1 23.1-23.1-23.1-23.1-23.1 23.1z" />
    <path d="M200.5 224.1c-2.2 0-4.4-.8-6-2.5l-35-35c-1.6-1.6-2.5-3.8-2.5-6s.9-4.4 2.5-6l10.9-10.8c10.4-10.4 16.1-24.2 16.1-38.9s-5.7-28.5-16.1-38.9l-.1-.1c-21.4-21.4-56.3-21.4-77.7 0h0c-8.5 8.5-13.9 19.3-15.6 31.2-1.6 11.5.5 23.4 5.9 33.6 2.2 4.1.7 9.3-3.5 11.5-4.1 2.2-9.3.7-11.5-3.5-7.1-13.3-9.9-29-7.8-44 2.2-15.6 9.2-29.7 20.4-40.8h0c13.6-13.6 31.7-21.1 50.9-21.1s37.3 7.5 50.9 21.1l.1.1c13.6 13.6 21.1 31.7 21.1 50.9s-7.5 37.3-21.1 50.9l-4.8 4.8 23 23 4.9-4.9c19.8-19.8 30.6-46 30.6-74s-10.9-54.2-30.7-74-46-30.6-74-30.6-54.2 10.9-74 30.6-30.6 46-30.6 74 10.9 54.2 30.6 74l4.9 4.9 29-29c3.3-3.3 8.7-3.3 12 0s3.3 8.7 0 12l-35 35c-3.3 3.3-8.7 3.3-12 0l-11-10.9c-11.6-11.6-20.6-25.1-26.7-40.2-5.9-14.6-8.9-30-8.9-45.8s3-31.2 8.9-45.8c6.1-15.1 15.1-28.6 26.7-40.2S70.6 18 85.7 11.9C100.2 6 115.6 3 131.4 3s31.2 3 45.8 8.9c15.1 6.1 28.6 15.1 40.2 26.7 11.6 11.6 20.6 25.2 26.7 40.3 5.9 14.6 8.9 30 8.9 45.8s-3 31.2-8.9 45.8c-6.1 15.1-15.1 28.6-26.7 40.2l-11 11c-1.6 1.6-3.8 2.5-5.9 2.5z" />
  </svg>
);

export default ZohoLogo;
